'use client';

import { useRef, useEffect } from 'react';
import { usePathname, useParams, useSearchParams } from 'next/navigation';
import gsap from 'gsap';
import { CustomEase } from 'gsap/all';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { useUi } from '@weareconceptstudio/core';
import { setSmoother } from './gsapSmootherInstance';

//? Plugin
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin, CustomEase);

function ScrollWrapper({ children }) {
	const { isBurgerMenuOpen, popupIsOpen } = useUi();

	//! Refs
	const main = useRef();
	const smoother = useRef();

	//! Next Navigation
	const pathname = usePathname();
	const params = useParams();
	const searchparams = useSearchParams();

	//! Scroll Top In Router Change
	useEffect(() => {
		if (smoother.current != undefined || smoother.current != null) {
			gsap.to(smoother.current, {
				scrollTop: 0,
				duration: 0,
			});
		}
		// //! searchparams not dynamic
	}, [pathname, params.lang, searchparams.get('categoryId'), searchparams.get('page')]);

	useGSAP(
		() => {
			//? Scroll off mobile
			let hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints;

			//? Smoother Desktop
			if (!hasTouchScreen) {
				smoother.current = ScrollSmoother.create({
					smooth: 0.7,
					speed: 1,
					ease: CustomEase.create('custom', 'M0,0 C0.11,0.354 0.134,0.963 1,1 '),
					normalizeScroll: { lockAxis: false, allowNestedScroll: true },
				});

				setSmoother(smoother.current);
			}
		},
		{ scope: main, dependencies: [pathname] }
	);

	useEffect(() => {
		if (smoother.current != undefined || smoother.current != null) {
			smoother.current.paused(isBurgerMenuOpen || popupIsOpen, true);
		}
	}, [isBurgerMenuOpen, popupIsOpen]);

	return (
		<div
			ref={main}
			id='smooth-wrapper'>
			<div id='smooth-content'>{children}</div>
		</div>
	);
}

export default ScrollWrapper;
